<template>
    <div class="jc-cell-list">
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'jc-list'
}
</script>

<style lang="scss">
.jc-cell-list {
    background: #fff;
    .jc-cell-wrapper {
        padding:  0 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/cell/list.vue